import { BTM_NAME_TM } from 'core/constants/products'

const BTM_MAP_NAMES = {
  'Plan 1': 'BTM_Basic',
  'Plan 2': 'BTM_Enhanced',
  'Plan 3': 'BTM_Preferred'
}

function mapBTMPlanName(plan) {
  return (
    (plan &&
      plan.planName &&
      BTM_MAP_NAMES[plan.planName.replace(`${BTM_NAME_TM} `, '')]) ||
    ''
  )
}

export default mapBTMPlanName
